import React from 'react'
import { Box, Button, Typography, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  gap: theme.spacing(3),
}))

const StyledButton = styled(Button)(({ theme }) => ({
  padding: '12px 24px',
  fontSize: '1.1rem',
  minWidth: '250px',
}))

export default function TimeOff() {
  const handleOpenTheraPortal = () => {
    window.open('https://app.getthera.com/home', '_blank')
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '85vh' }}>
      <StyledPaper>
        <CalendarTodayIcon sx={{ fontSize: 60, color: 'primary.main' }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Time Off Request
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', mb: 2 }}>
          Click the button below to open the Thera time off portal in a new tab.
        </Typography>
        <StyledButton
          variant="contained"
          color="primary"
          onClick={handleOpenTheraPortal}
          startIcon={<CalendarTodayIcon />}
        >
          Open Time Off Portal
        </StyledButton>
      </StyledPaper>
    </Box>
  )
}
